import {
  SUPER_ADMIN_ROLE_ID,
  ULTRA_SUPER_ADMIN_ROLE_ID,
} from '../../const/config';

const RAMUS_SUPER_ADMIN_ROLE_IDS = [
  SUPER_ADMIN_ROLE_ID,
  '01ea8fc7-4a7a-4063-961f-ea3626f07ac4',
];

const WHITE_LABEL_SUPER_ADMIN_ROLE_IDS = [
  ...RAMUS_SUPER_ADMIN_ROLE_IDS,
  '9c349a36-64f2-4b4d-8b2b-ffeba9749738',
  'eea16c4c-6abd-491e-a6ed-5e0ee2d605d1',
  'e88b1f59-51d2-418a-8e81-d765b1828a99',
];

const WHITE_LABEL_SUPER_ADMIN_ROLE_NAMES = [
  'SUPERADMIN RAMUS',
  'SUPER ADMIN RAMUS',
  'SUPERADMIN PINISI',
  'SUPER ADMIN PINISI',
  'SUPERADMIN NETRA',
  'SUPER ADMIN NETRA',
  'SUPERADMIN BKI',
  'SUPER ADMIN BKI',
];

export function canManageAssetAliasSource(role?: {
  roleId?: string | null;
  roleName?: string | null;
}) {
  const roleId = role?.roleId || '';
  const roleName = (role?.roleName || '').toUpperCase();

  return (
    roleId === ULTRA_SUPER_ADMIN_ROLE_ID ||
    RAMUS_SUPER_ADMIN_ROLE_IDS.includes(roleId) ||
    roleName.includes('ULTRA SUPERADMIN') ||
    roleName.includes('SUPERADMIN RAMUS') ||
    roleName.includes('SUPER ADMIN RAMUS') ||
    roleName.includes('SUPERADMIN PINISI') ||
    roleName.includes('SUPER ADMIN PINISI')
  );
}

export function canUpdateRamus2OperationModeSpeedConfig(role?: {
  roleId?: string | null;
}) {
  const roleId = role?.roleId || '';

  return (
    roleId === ULTRA_SUPER_ADMIN_ROLE_ID ||
    RAMUS_SUPER_ADMIN_ROLE_IDS.includes(roleId)
  );
}

export function canManageTelemetryMqttClient(role?: {
  roleId?: string | null;
  roleName?: string | null;
}) {
  const roleId = role?.roleId || '';
  const roleName = (role?.roleName || '').toUpperCase();

  return (
    roleId === ULTRA_SUPER_ADMIN_ROLE_ID ||
    WHITE_LABEL_SUPER_ADMIN_ROLE_IDS.includes(roleId) ||
    roleName.includes('ULTRA SUPERADMIN') ||
    roleName.includes('ULTRA SUPER ADMIN') ||
    WHITE_LABEL_SUPER_ADMIN_ROLE_NAMES.some((item) =>
      roleName.includes(item)
    )
  );
}
